import { render, staticRenderFns } from "./DashboardSharelink.vue?vue&type=template&id=0a6c6ade&scoped=true&"
import script from "./DashboardSharelink.vue?vue&type=script&lang=js&"
export * from "./DashboardSharelink.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSharelink.vue?vue&type=style&index=0&id=0a6c6ade&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c6ade",
  null
  
)

export default component.exports